(() => {
  if (customElements.get('cyril-lookbook')) return;
  class Lookbook extends HTMLElement {
    connectedCallback() {
      if (this.started) return; this.started = true;
      this.config = JSON.parse(this.querySelector('.clb__config').textContent);
      this.grid = this.querySelector('.clb__grid'); this.status = this.querySelector('.clb__status');
      this.more = this.querySelector('.clb__more'); this.dialog = this.querySelector('dialog');
      this.large = this.querySelector('.clb__large'); this.counter = this.querySelector('.clb__counter');
      this.previous = this.querySelector('.clb__prev'); this.next = this.querySelector('.clb__next');
      this.grid.replaceChildren(); this.items = []; this.seen = new Set(); this.offset = 0; this.busy = false; this.failed = false;
      this.controller = new AbortController(); const {signal} = this.controller;
      this.index = this.order(this.config.index || [], this.config.mode);
      this.indexReady = !(this.config.pages || []).length;this.catalogReady=false;this.lastCatalogCheck=0;
      const revisit=()=>this.checkForUpdates();
      window.addEventListener('focus',revisit,{signal});
      window.addEventListener('pageshow',revisit,{signal});
      document.addEventListener('visibilitychange',revisit,{signal});
      this.refreshTimer=setInterval(()=>{if(this.offset>=this.index.length)this.checkForUpdates();},60000);
      this.more.addEventListener('click', () => {this.failed = false; this.load();}, {signal});
      this.querySelector('.clb__close').addEventListener('click', () => this.dialog.close(), {signal});
      this.previous.addEventListener('click', () => this.show(this.current - 1), {signal});
      this.next.addEventListener('click', () => this.advance(), {signal});
      this.dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') {e.preventDefault(); this.show(this.current - 1);}
        if (e.key === 'ArrowRight') {e.preventDefault(); this.advance();}
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.oldOverflow || '';
        this.returnFocus?.focus({preventScroll: true});
      }, {signal});
      this.large.addEventListener('touchstart', e => {
        this.touch = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
      }, {signal, passive:true});
      this.large.addEventListener('touchend', e => {
        if (!this.touch || !e.changedTouches.length) return;
        const dx=e.changedTouches[0].clientX-this.touch.x, dy=e.changedTouches[0].clientY-this.touch.y;
        if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) dx<0 ? this.advance() : this.show(this.current-1);
        this.touch=null;
      }, {signal, passive:true});
      this.resize = new ResizeObserver(() => this.layout()); this.resize.observe(this.grid);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(e=>e.isIntersecting) && !this.dialog.open && !this.failed) this.load();
      }, {rootMargin:'700px 0px'});
      this.observer.observe(this.querySelector('.clb__loader'));
      this.load();
    }
    disconnectedCallback() {
      if(this.dialog?.open) this.dialog.close();
      this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();clearInterval(this.refreshTimer);
      this.started=false;
    }
    order(index, mode) {
      const rows=index.slice(); const recent=(a,b)=>b.createdAt.localeCompare(a.createdAt)||a.id.localeCompare(b.id);
      if(mode==='random') {
        for(let i=rows.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[rows[i],rows[j]]=[rows[j],rows[i]];}
      } else rows.sort(mode==='manual' ? (a,b)=>(a.position||Infinity)-(b.position||Infinity)||recent(a,b) : mode==='oldest' ? (a,b)=>-recent(a,b) : recent);
      return rows;
    }
    async request(query, variables) {
      const timeout = new AbortController();
      const abort = () => timeout.abort();
      this.controller.signal.addEventListener('abort', abort, {once:true});
      const timer = setTimeout(abort, 20000);
      try {
        const response = await fetch(this.config.endpoint, {method:'POST', signal:timeout.signal,
          headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':this.config.token},
          body:JSON.stringify({query, variables})});
        if(!response.ok) throw new Error('request');
        const result = await response.json();
        if(result.errors) throw new Error('data');
        if(Array.isArray(result.data?.nodes))return result.data.nodes;
        if(result.data?.metaobject)return [result.data.metaobject];
        throw new Error('data');
      } finally {clearTimeout(timer);this.controller.signal.removeEventListener('abort', abort);}
    }
    checkForUpdates(){
      if(!this.started||document.hidden||this.busy||Date.now()-this.lastCatalogCheck<2000)return;
      this.catalogReady=false;this.failed=false;this.load();
    }
    async load() {
      if(this.busy || (this.catalogReady && this.indexReady && this.offset>=this.index.length)){this.updateStatus();return;}
      if(!this.config.token){this.failed=true;this.status.textContent='The lookbook is being prepared. Please check back soon.';return;}
      this.busy=true;this.more.hidden=true;this.status.textContent='Loading photographs…';
      try {
        if(!this.catalogReady){
          const [catalog]=await this.request('query Catalog{metaobject(handle:{type:"cyril_lookbook_catalog",handle:"published"}){index:field(key:"index"){value} pages:field(key:"pages"){value} mode:field(key:"mode"){value}}}',{});
          this.pendingIndex=JSON.parse(catalog.index?.value||'[]');
          this.config.pages=JSON.parse(catalog.pages?.value||'[]');
          this.config.mode=catalog.mode?.value||'newest';this.indexReady=false;
        }
        if(!this.indexReady) {
          const entries=(this.pendingIndex||[]).slice();
          for(let offset=0;offset<this.config.pages.length;offset+=20) {
            const pages=await this.request('query Index($ids:[ID!]!){nodes(ids:$ids){... on Metaobject{id entries:field(key:"entries"){value}}}}', {ids:this.config.pages.slice(offset,offset+20)});
            if(pages.some(page=>!page?.entries?.value)) throw new Error('index');
            for(const page of pages) entries.push(...JSON.parse(page.entries.value));
          }
          const fresh=this.order([...new Map(entries.map(entry=>[entry.id,entry])).values()],this.config.mode);
          if(this.offset){
            // Preserve this visit's displayed order; append new uploads without duplicates.
            const previousIds=new Set(this.index.map(entry=>entry.id));const freshIds=new Set(fresh.map(entry=>entry.id));
            this.index=[...this.index.slice(0,this.offset),...this.index.slice(this.offset).filter(entry=>freshIds.has(entry.id)),...fresh.filter(entry=>!previousIds.has(entry.id))];
          }else this.index=fresh;
          this.indexReady=true;this.catalogReady=true;this.lastCatalogCheck=Date.now();
        }
        const batch=this.index.slice(this.offset,this.offset+this.config.batchSize);
        if(!batch.length) return;
        const rows=await this.request('query Photos($ids:[ID!]!){nodes(ids:$ids){... on Metaobject{id source:field(key:"source"){value} hidden:field(key:"hidden"){value}}}}',{ids:batch.map(p=>p.id)});
        const nodes=new Map(rows.filter(Boolean).map(n=>[n.id,n]));
        const fragment=document.createDocumentFragment();
        for(const entry of batch){
          const node=nodes.get(entry.id);if(!node || node.hidden?.value==='true' || this.seen.has(node.id))continue;
          let source;try{source=JSON.parse(node.source?.value||'{}');}catch{continue;}
          const actual=source;
          if(!source.present || !actual?.width || !actual?.height)continue;
          let parsed;try{parsed=new URL(actual.url);}catch{continue;}if(parsed.protocol!=='https:')continue;
          const photo={...source,...actual,id:node.id,alt:actual.altText||source.alt||'CYRIL helmet photography'};
          const item=document.createElement('div');item.className='clb__item';item.setAttribute('role','listitem');
          const button=document.createElement('button');button.type='button';button.className='clb__photo';button.setAttribute('aria-label',`View photograph ${this.items.length+1}: ${photo.alt}`);
          const image=document.createElement('img');image.width=photo.width;image.height=photo.height;image.alt=photo.alt;
          image.src=this.imageUrl(photo.url,600);image.srcset=[320,480,640,800,1000].filter(w=>w<=photo.width).map(w=>`${this.imageUrl(photo.url,w)} ${w}w`).join(',');
          image.sizes='(max-width: 749px) 46vw, (max-width: 1099px) 30vw, 23vw';image.loading=this.items.length<4?'eager':'lazy';image.decoding='async';
          const position=this.items.length;button.addEventListener('click',()=>this.open(position,button),{signal:this.controller.signal});
          image.addEventListener('error',()=>{image.alt='Photograph temporarily unavailable';},{once:true});
          button.append(image);item.append(button);fragment.append(item);this.items.push({photo,element:item});this.seen.add(photo.id);
        }
        this.grid.append(fragment);this.offset+=batch.length;this.failed=false;this.layout();
      }catch(error){if(!this.controller.signal.aborted){this.failed=true;this.status.textContent='Could not load more photographs.';this.more.textContent='Try again';this.more.hidden=false;}}
      finally{this.busy=false;if(this.controller.signal.aborted)return;if(!this.failed){this.updateStatus();requestAnimationFrame(()=>{if(this.offset<this.index.length && !this.dialog.open && this.querySelector('.clb__loader').getBoundingClientRect().top<innerHeight+700)this.load();});}}
    }
    imageUrl(src,width){const u=new URL(src);u.searchParams.set('width',width);return u.href;}
    layout(){
      const width=this.grid.clientWidth;if(!width)return;const columns=Math.min(this.items.length||1,width>=1200?4:width>=750?3:width>=300?2:1);
      const gap=width<750?10:16;const itemWidth=(width-gap*(columns-1))/columns;const heights=Array(columns).fill(0);
      for(const item of this.items){const column=heights.indexOf(Math.min(...heights));const height=itemWidth*item.photo.height/item.photo.width;
        item.element.querySelector('img').sizes=`${Math.ceil(itemWidth)}px`;
        Object.assign(item.element.style,{width:`${itemWidth}px`,height:`${height}px`,transform:`translate(${column*(itemWidth+gap)}px,${heights[column]}px)`});heights[column]+=height+gap;}
      this.grid.style.height=`${Math.max(0,...heights)- (this.items.length?gap:0)}px`;
    }
    updateStatus(){if(this.failed||this.busy)return;const ended=this.offset>=this.index.length;
      this.status.textContent=!this.index.length?'New photographs are coming soon.':ended?(this.items.length?'You’ve seen the complete lookbook.':'Photographs are temporarily unavailable. Please check back soon.'):'';
      this.more.hidden=ended;this.more.textContent='Load more';}
    open(index,button){this.returnFocus=button;this.oldOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.show(index);}
    show(index){if(index<0||index>=this.items.length)return;this.current=index;const {photo}=this.items[index];
      this.large.src=this.imageUrl(photo.url,Math.min(photo.width,2400));this.large.alt=photo.alt;this.large.width=photo.width;this.large.height=photo.height;
      this.counter.textContent=`${index+1} / ${this.offset>=this.index.length?this.items.length:this.index.length}`;this.previous.disabled=index===0;this.next.disabled=index===this.items.length-1 && this.offset>=this.index.length;}
    async advance(){if(this.busy)return;if(this.current===this.items.length-1 && this.offset<this.index.length)await this.load();this.show(this.current+1);}
  }
  customElements.define('cyril-lookbook',Lookbook);
})();
